module.exports = __webpack_public_path__ + "img/checkout-form.79d0eb00.svg";